module.exports = __webpack_public_path__ + "static/img/09.108c85a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/73/new/09.gif
// module id = oap4
// module chunks = 0